export * from './landings.module';
export * from './shared';


// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/landings/index.ts